// Claude - https://docs.anthropic.com/en/docs/about-claude/models#model-names
// ChatGPT - https://platform.openai.com/docs/models#models-overview
// Gemini - https://ai.google.dev/gemini-api/docs/models/gemini#gemini-1.5-flash

export enum EngineEnum {
  CLAUDE_3_5_SONNET_20240620 = 1, // default, sonnet training data cut off: 2024-06-20
  CLAUDE_3_5_SONNET_20241022 = 2, // sonnet training data cut off: 2024-10-22
  CLAUDE_3_OPUS_20240229 = 3,
  CLAUDE_3_5_HAIKU_20241022 = 4,
  GPT_4O_MINI_2024_07_18 = 5,
  GPT_4_TURBO_2024_04_09 = 6,
  GEMINI_1_5_PRO = 7,
  O3_MINI_2025_01_31 = 8,
  CLAUDE_3_7_SONNET_20250219 = 9,
  GPT_5_2025_08_07 = 10,
  GPT_5_MINI_2025_08_07 = 11,
  GPT_5_NANO_2025_08_07 = 12,
  CLAUDE_SONNET_4_5 = 13,
}
